import { useEffect } from 'react';

import { BackHandler } from 'react-native';

import { isWeb } from 'utils/responsiveness';

type Props = {
    visible: boolean;
    onHardwareBackPress(): void;
};

function usePlayerBackHandler({ visible, onHardwareBackPress }: Props) {
    useEffect(() => {
        let backHandler:
            | undefined
            | ReturnType<typeof BackHandler.addEventListener>;

        if (!isWeb && visible) {
            backHandler = BackHandler.addEventListener(
                'hardwareBackPress',
                () => {
                    onHardwareBackPress();

                    return true;
                },
            );
        }

        return () => {
            if (backHandler) {
                backHandler.remove();
            }
        };
    }, [visible, onHardwareBackPress]);
}

export default usePlayerBackHandler;
